// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay-scroll-wrapper{height:100%;width:100%;overflow:auto}", "",{"version":3,"sources":["webpack://src/components/VirtuosoOverlayScrollbar/virtuosoOverlayScrollbar.scss"],"names":[],"mappings":"AAAA,wBACC,WAAA,CACA,UAAA,CACA,aAAA","sourcesContent":[".overlay-scroll-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\toverflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
